import { CONTENT_HIGHLIGHTS_ENTRY_SOURCE_GLOBAL_SEARCH } from './entry-source'
import {
  isUnifiedSearchExperimentEligible,
  resolveUnifiedSearchWebVariant,
  shouldRecordUnifiedSearchExperimentExposure,
  UNIFIED_SEARCH_WEB_VARIANTS,
} from './unified-search-experiment'

/**
 * Hold ai-search-web exposure while logged-in entitlement may still hydrate on /search.
 */
export function shouldDeferAiSearchExperimentExposure ({
  helmEnabled,
  hasJwt,
  hasAccess,
  processingRenew,
  bootstrapComplete,
  subscriptionsHydrated,
}) {
  if (!helmEnabled || !hasJwt || hasAccess) {
    return false
  }
  if (processingRenew) {
    return true
  }
  if (!bootstrapComplete || !subscriptionsHydrated) {
    return true
  }
  return false
}

/**
 * Build the experiment_exposure payload for /search, or null when none should fire.
 */
export default function getSearchPageExperimentExposure ({
  helmEnabled,
  hasAccess,
  query,
  unifiedSearchVariant,
  aiSearchVariant,
  hasJwt = false,
  processingRenew = false,
  bootstrapComplete = true,
  subscriptionsHydrated = true,
  appEnv,
}) {
  const trimmedQuery = String(query || '').trim()
  if (!trimmedQuery) {
    return null
  }

  const unifiedSearchEligible = isUnifiedSearchExperimentEligible({
    helmEnabled,
    hasAccess,
    query: trimmedQuery,
    entrySource: CONTENT_HIGHLIGHTS_ENTRY_SOURCE_GLOBAL_SEARCH,
  })

  if (unifiedSearchEligible) {
    if (!shouldRecordUnifiedSearchExperimentExposure(appEnv)) {
      return null
    }
    const effectiveVariant = resolveUnifiedSearchWebVariant({
      posthogVariant: unifiedSearchVariant,
      appEnv,
    })
    if (typeof effectiveVariant !== 'string'
      || !UNIFIED_SEARCH_WEB_VARIANTS.includes(effectiveVariant)) {
      return null
    }
    return {
      experiment: 'unified-search-web',
      properties: {
        '$feature/unified-search-web': effectiveVariant,
        experiment: 'unified-search-web',
        entry_source: CONTENT_HIGHLIGHTS_ENTRY_SOURCE_GLOBAL_SEARCH,
      },
    }
  }

  if (aiSearchVariant === 'test' || aiSearchVariant === 'control') {
    if (shouldDeferAiSearchExperimentExposure({
      helmEnabled,
      hasJwt,
      hasAccess,
      processingRenew,
      bootstrapComplete,
      subscriptionsHydrated,
    })) {
      return null
    }
    return {
      experiment: 'ai-search-web',
      properties: {
        '$feature/ai-search-web': aiSearchVariant,
        experiment: 'ai-search-web',
      },
    }
  }

  return null
}
